import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const token = localStorage.getItem('jwt') ?? localStorage.getItem('jwt-password');

  // Adiciona o token ao cabeçalho da requisição, se existir
  const authReq = token ? req.clone({
    setHeaders: { Authorization: `Bearer ${token}` }
  }) : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Token expirado/inválido: remove antes de redirecionar. Sem isso os
        // guards continuam vendo um token no localStorage e chamam a API de
        // novo na navegação para /login, gerando outro 401 e um loop de
        // redirecionamentos que nunca termina (tela em branco).
        if (token) {
          localStorage.removeItem('jwt');
          localStorage.removeItem('jwt-password');
          localStorage.removeItem('customerId');
        }
        // Redireciona para a página de login em caso de erro 401
        router.navigate(['/login']);
      }
      return throwError(error);
    })
  );
};
